/**
 * @module FE-CU07_トップ画面
 */
import Header from '../../components/header/Header.vue';
import Nav from '../../components/nav/Nav.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import News from '../../components/news/News.vue';
import OperationControl from '../../components/operationControl/OperationControl.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import TabHeader from '../../components/tabHeader/TabHeader.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import ConfirmDialog from '../../components/dialog/ConfirmDialog.vue';
import AgreementDialog from '../../components/modal/agreementDialog.vue';
import AgreementBtnColDialog from '../../components/modal/agreementBtnColDialog.vue';
import NativeApi from '../../api/nativeApi';
import NativeCallback from '../../api/nativeCallback';
import PCFooter from '@/components/footer/PCFooter';
import SecuritySwitch from '../../components/securitySwitch/SecuritySwitch.vue';
import TimeParser from '../../utile/timeParser';
import Paginate from 'vuejs-paginate';
import ExternalUrl from '../../api/externalLinks/externalUrls';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU07';

export default {
  name: 'top',
  components: {
    Header,
    Nav,
    BreadCrumbList,
    News,
    OperationControl,
    MobileFooter,
    TabHeader,
    PcPageTitle,
    ConfirmDialog,
    AgreementDialog,
    AgreementBtnColDialog,
    PCFooter,
    SecuritySwitch,
    Paginate,
  },
  data(vm) {
    return {
      securityAreaPage: 1,
      securityAreaPageLength: 0,
      displayDistrictPage: 1,
      displayDistrictPageLength: 0,
      // 対象地区選択ダイアログ
      selectLocateDialog: false,
      // 一括警備操作適用確認ダイアログ
      confirmBulk: false,
      // 在宅対象確認ダイアログ
      remoteDialog: false,
      // 警備設定確認ダイアログ
      confirmDialogFlg: false,
      // PUSH通知設定確認ダイアログ
      pushNotificationSettingDialog: false,
      title: vm.$vuetify.lang.t('$vuetify.FECU07.トップ'), //"トップ",
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU07トップ画面.C0001'),
      // "ホームセキュリティのユーザー警備操作を行うことができます。\n対象地区選択ボタン(名称TBD)を押して警備操作を行う地区を選択してください。地区は複数選択することができます。\n在宅警備を行うエリアを指定したい場合は、在宅対象確認ボタンを押して在宅対象エリアを選択してください。",
      goOutTabImage_active: require('../../assets/images/top/icon_go_out.svg'),
      atHomeTabImage_active: require('../../assets/images/top/icon_at_home.svg'),
      liftTabImage_active: require('../../assets/images/top/icon_lift.svg'),
      goOutTabImage: require('../../assets/images/top/icon_go_out.svg'),
      atHomeTabImage: require('../../assets/images/top/icon_at_home.svg'),
      liftTabImage: require('../../assets/images/top/icon_lift.svg'),
      id: '',
      text: '',
      src: '',
      tabNumber: 0,
      pushNotificationDeliveryInfoList: [], // 対象地区ごとのPUSH通知リスト
      // Nativeでの設定アプリ起動結果を保持
      nativeCallbackResult: {
        errorCode: '',
      },
      securityStatus: 'N', // 警備状態
      securityStatusText: '', // 警備状態表示（項目No78）
      newsInfo: [],
      securityAreaList: [],
      districtIndexList: [],
      originalDistrictList: {},
      displayDistrictList: {},
      districtList: {},
      disabled: {
        homeSecurity: false,
        camera: false,
        displayDistrict: false,
        securityOperation9916: true,
        selectSecurityDistrict: false,
        selectSecurityArea: false,
        LocateDialog: true,
      },
      existsSecurityAreaList: [],
      selectSecurityAreaList: [],
      districtMessage: '',
      displayDistrictInfoList: [],
      cameraInfoList: [],
      saveDisplayDistrictInfoList: [],
      simpleServiceInfoList: [],
      listRow: 0,
      settingCustomerNumber: '',
      settingDistrictSplitNumber: '',
      selectSecurityDistrictCount: 0,
      selectSecurityStatus: '',
      tmpAuthority: {},
      displayNickName: '',
      totalVisiblePageItem: 3,
      securityUnitExecutionResults: [],
      absenceSwitch: false,
      athomeSwitch: false,
      dontSelectFlag: false,
      securitySwitchReset: false,
      existsSecurityOnGuardFlag: false,
      existsSecuritySelfPlanFlag: false,
      CONSTANTS: CONSTANTS,
      needPushNotificationPermissionCount: 0,
      isVisible: false,
      connectionSucceededSecurityUnitCustomerNumberList: [],
      multipleChoice: false,
      serviceButtonInitFlag: false,
      //ページの表示タイミング
      isShowPage: false,
      upsellUrl: 'https://www.alsok.co.jp/person/recommend/',
      buttonList: [
        {
          id: '1',
          isShow: false,
          isHidden: false,
          divclass: 'iconst',
          linenum: 2,
          line1: '$vuetify.FECU07.ホーム',
          line2: '$vuetify.FECU07.セキュリティ',
          viewBox: '0 0 45.525 43.401',
          xlink: require('../../assets/images/top/sp-home-security.svg') + '#home_security',
          click: null,
        },
        {
          id: '2',
          isShow: false,
          isHidden: false,
          divclass: 'icons',
          linenum: 1,
          line1: '$vuetify.FECU07.カメラ',
          line2: '',
          viewBox: '0 0 35.21 35.21',
          xlink: require('../../assets/images/top/sp-camera.svg') + '#camera',
          click: null,
        },
        {
          id: '3',
          isShow: true,
          isHidden: false,
          divclass: 'icons',
          linenum: 1,
          line1: '$vuetify.FECU07.健康相談等',
          line2: '',
          viewBox: '0 0 14 14',
          xlink: require('../../assets/images/top/homesecurity_7.svg') + '#contact',
          click: null,
        },
        {
          id: '4',
          isShow: true,
          isHidden: false,
          divclass: 'icons',
          linenum: 1,
          line1: '$vuetify.FECU07.アップ',
          line2: '$vuetify.FECU07.グレード',
          viewBox: '0 0 578.25067 564.58161',
          xlink: require('../../assets/images/top/upgrade.svg') + '#svg7468',
          click: null,
        },
      ],
      defButtonElement: {
        id: '0',
        isShow: false,
        isHidden: true,
        divclass: 'icons',
        line1: '',
        line2: '',
        viewBox: '',
        xlink: null,
        click: null,
      },
      buttonLine: [],
      buttonKeyPrefix: '',
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU07.トップ'), //"トップ",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU07トップ画面.C0001'),
      };
    },
    isPushNotificationAvailable() {
      return this.$store.getters['appInfo/getIsPushNotificationAvailable'];
    },
    disableChangeSecurity() {
      if (
        !Object.keys(this.districtList).length ||
        !this.connectionSucceededSecurityUnitCustomerNumberList.length ||
        !this.districtIndexList.length
      ) {
        return true;
      }
      // 選択中の対象地区の内、全てについて通信が成功した場合は「警備状態を変更」ボタンを活性化する
      let self = this;
      let disableFlag = this.districtIndexList.some(function (districtIndex) {
        return (
          self.districtList[districtIndex].bulkSecurityOperationFlg &&
          !self.connectionSucceededSecurityUnitCustomerNumberList.includes(
            self.districtList[districtIndex].customerNumber
          )
        );
      });
      // 選択中の対象地区の内、全てについて通信が成功した場合は
      // 警備操作設定領域の選択状態にも反映する
      if (!disableFlag) {
        if (self.existsSecurityOnGuardFlag) {
          // 複数選択中の地区に警備中がある場合、「警備解除」を選択
          self.tabNumber = 2;
          this.securitySwitchReset = !this.securitySwitchReset;
        } else if (self.existsSecuritySelfPlanFlag) {
          // 複数選択中の地区にセルフ契約がある場合、「外出セルフ」を選択
          self.tabNumber = 0;
          self.absenceSwitch = false;
          self.athomeSwitch = false;
          this.securitySwitchReset = !this.securitySwitchReset;
        } else {
          // 上記以外の場合、「外出ALSOK」を選択
          self.tabNumber = 0;
          self.absenceSwitch = true;
          self.athomeSwitch = true;
          this.securitySwitchReset = !this.securitySwitchReset;
        }
        // オンライン監視プラン以外のプランを1つ以上選択中の場合セルフに固定
        if (self.dontSelectFlag) {
          self.absenceSwitch = false;
          self.athomeSwitch = false;
        }
      }
      return disableFlag;
    },
    disableSecurityOperation() {
      //外出、解除タブ
      return this.districtIndexList.length == 0 || this.disabled.securityOperation9916;
    },
    disableExistsSecurityArea() {
      //在宅タブ
      return (
        this.districtIndexList.length == 0 ||
        [...this.existsSecurityAreaList, ...this.selectSecurityAreaList].filter(
          (area) =>
            this.existsSecurityAreaList.includes(area) && this.selectSecurityAreaList.includes(area)
        ).length == 0
      );
    },
    statusMessage() {
      return this.selectSecurityDistrictCount === 1 ? this.selectSecurityStatus : '';
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 初期処理
     */
    init: async function () {
      let param = '/api/top/init';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = await this.APP_CU0701(param, queries, method);

      // 対象地区の初期表示
      this.displayDistrictMessage();

      if (typeof apiData.contentsInfo !== 'undefined') {
        let promiseList = [];
        this.$store.commit('requestApi/setInterruptionFlag', false);
        this.securityUnitExecutionResults = [];
        this.selectSecurityDistrictCount = 0;
        let loopIndex = 0;
        let basetime = 100; // 基準時間ms
        for (const unitCommand of apiData.contentsInfo.unitCommandInfo) {
          if (unitCommand.sendCommandKey === '') {
            continue;
          }
          loopIndex += 1;
          // テストコード
          // apiData.contentsInfo.unitCommandInfo.forEach((unitCommand, index) => {
          let params = {
            token: sessionStorage.getItem('token'),
            terminalInfo: localStorage.getItem('terminalInfo')
              ? localStorage.getItem('terminalInfo')
              : '',
            sendCustomerNumber: unitCommand.sendCustomerNumber,
            sendCommandKey: unitCommand.sendCommandKey,
            apiId: 0,
            alarmType: 0,
            districtSplitNumber: '',
            securityAreaId: '',
          };
          // APP_CO9915
          promiseList.push(this.APP_CU0701_CO9915(params, loopIndex * basetime));
          // テストコード
          // promiseList.push(this.APP_CU0701_CO9915(params, index));
        }

        if (promiseList.length != 0) {
          // APP_CU0701_CO9915を並列実行
          await Promise.all(promiseList).catch(() => {
            // console.log(error);
          });
        }
        // 対象地区のうち、通信が成功したものが1件でもあればinterruptionFlagをfalseにする
        if (this.connectionSucceededSecurityUnitCustomerNumberList.length > 0) {
          this.$store.commit('requestApi/setInterruptionFlag', false);
        }

        // 画面遷移が行われたらinterruptionFlagをfalseにして処理を抜ける
        if (this.$route.path !== '/top') {
          this.$store.commit('requestApi/setInterruptionFlag', false);
          return;
        }

        if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
          // 正常
          if (this.districtIndexList.length == 0) {
            this.disabled.displayDistrict = true;
          } else {
            this.disabled.LocateDialog = false; // 対象地区選択ボタン
          }

          // 遷移元が、2段階認証画面もしくはログイン画面の場合、スマホアプリにてPUSH通知確認ダイアログを表示するかを判断する
          if (this.$isMobileApp) {
            const from = this.$route.query.from;
            if (from === 'login' || from === 'TwoStepAuthentication') {
              await this.openMobileAppPushDialog();
            }
          }
        } else {
          // 異常
          if (this.securityUnitExecutionResults.length != 0) {
            this.$store.commit('requestApi/setInterruptionFlag', false);
            this.$_securityUnitExecutionResultsDialog(this.securityUnitExecutionResults);
          } else {
            this.$store.commit('requestApi/setInterruptionFlag', false);
            this.$_securityUnitExecutionResultDialog(-1);
          }
        }

        this.setPagenationTabIndex();
      }
      //no good!!!!!
      //ボタン更新(ここは、警備ユニット/カメラがあるユーザーのために必要、最新情報に更新される。)
      this.buttonListUpdate();
    },
    /**
     * ホームセキュリティボタン押下処理
     */
    returnDisplayDistrict() {
      if (this.$store.state.districtOneCountFlag) {
        // 対象地区が1地区の場合、対象地区詳細画面に遷移する。
        this.$store.commit('setCustomerNumber', {
          customerNumber: this.$store.state.oneDistrictCustomerNumber,
        });
        this.$store.commit('setDistrictSplitNumber', {
          districtSplitNumber: this.$store.state.oneDistrictSplitNumber,
        });
        this.$router.push('/displayDistrictDetail');
      } else {
        // 対象地区が2地区以上存在するの場合、ホームセキュリティ画面に遷移する。
        this.$router.push('/homeSecurity');
      }
    },
    /**
     * カメラボタン押下処理
     */
    returnCamera() {
      if (this.$store.state.cameraOneCountFlag) {
        // カメラが1台の場合、カメラ詳細画面に遷移する。
        this.$store.commit('setCustomerNumber', {
          customerNumber: this.$store.state.oneCameraCustomerNumber,
        });
        this.$store.commit('setDeviceID', {
          deviceID: this.$store.state.oneCameraDeviceID,
        });
        this.$router.push('/cameraDetail');
      } else {
        // カメラが2台以上の場合、カメラ画面に遷移する。
        this.$router.push('/camera');
      }
    },
    /**
     * 健康相談等ボタン押下処理
     */
    returnContactUsHouseSupport() {
      // ハウスサポート画面に遷移
      this.$router.push('/contactUsHouseSupport');
    },
    /**
     * サービス追加ボタン押下処理
     */
    async returnServiceAdd() {
      // サービス追加画面に遷移senni
      if (this.$isMobileApp) {
        const result = await this.$agreementDialog(
          '$vuetify.agreementDialog.確認',
          '$vuetify.メッセージ一覧.FECU07トップ画面.C0017',
          '$vuetify.agreementDialog.いいえボタン',
          '$vuetify.agreementDialog.はいボタン'
        );
        if (result) {
          // ログイン引継トークン発行
          let param = '/api/common/issueTakeoverToken';
          let queries = {
            token: sessionStorage.getItem('token'),
            terminalInfo: localStorage.getItem('terminalInfo')
              ? localStorage.getItem('terminalInfo')
              : '',
          };
          let method = 'post';
          await this.APP_CU9912(param, queries, method);

          let serviceAddUrl = ExternalUrl.alsockWebAppServiceAddManagement;
          NativeApi.openExternalBrowserWithToken(serviceAddUrl);
          // this.$router.push('/Top');   // old logic

          // logout
          sessionStorage.removeItem('token');
          this.$store.commit('setIsLoggedIn', { isLoggedIn: false });
          this.$router.replace({
            path: '/login',
            query: { isFromLogout: true },
          });
        } else {
          // only close Dialog
        }
      } else {
        this.$router.push('/serviceAdd');
      }
    },
    /**
     * ログイン引継トークン発行(APP_CO9912)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU9912: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo: {
            //     takeoverToken: 'string'
            //   }
            // }
            sessionStorage.setItem('takeoverToken', apiData.contentsInfo.takeoverToken ?? '');
          },
          (error /* eslint-disable-line */) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * 警備設定確認ダイアログ表示処理
     */
    async callSaveAgreementDialog(securityStatus) {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.agreementDialog.警備状態を変更します',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
        // "確認",
        // "警備状態を変更します。\n\rよろしいでしょうか。",
        // "いいえ",
        // "はい"
      );
      if (result === true) {
        // はいを押すと更新処理実行
        this.$_setLoadingAlsok(true, securityStatus);

        // APP_CU0702 一括警備設定_登録処理
        let apiData = await this.APP_CU0702(securityStatus);

        if (typeof apiData.contentsInfo !== 'undefined') {
          let promiseList = [];
          this.$store.commit('requestApi/setInterruptionFlag', false);
          this.securityUnitExecutionResults = [];
          apiData.contentsInfo.unitCommandInfo.forEach((unitCommand) => {
            // テストコード
            // apiData.contentsInfo.unitCommandInfo.forEach((unitCommand, index) => {
            let params = {
              token: sessionStorage.getItem('token'),
              terminalInfo: localStorage.getItem('terminalInfo')
                ? localStorage.getItem('terminalInfo')
                : '',
              sendCustomerNumber: unitCommand.sendCustomerNumber,
              sendCommandKey: unitCommand.sendCommandKey,
              apiId: 1,
              alarmType: 0,
              districtSplitNumber: '',
              securityAreaId: '',
            };
            // APP_CO9915
            let sendCustomerNumber = unitCommand.sendCustomerNumber;
            promiseList.push(this.APP_CU0702_CO9915(params, sendCustomerNumber));
            // テストコード
            // promiseList.push(this.APP_CU0702_CO9915(params, index));
          });

          if (promiseList.length != 0) {
            // APP_CU0702_CO9915を並列実行
            await Promise.all(promiseList).catch(() => {
              // console.log(error);
            });
          }

          if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
            // 正常
            try {
              if (this.saveDisplayDistrictInfoList.length != 0) {
                // ダイアログを表示
                let complete = [];
                let sfrInfo = [];
                let same = [];
                let error = [];
                this.saveDisplayDistrictInfoList.forEach((saveDisplayDistrictInfo) => {
                  switch (saveDisplayDistrictInfo.securityStatusChangeResult) {
                    case 0:
                      // 0: OKの場合
                      complete.push(
                        this.originalDistrictList[
                          saveDisplayDistrictInfo.sendCustomerNumber +
                            saveDisplayDistrictInfo.securityDistrictNumber
                        ].displayDistrictNickname
                      );
                      break;
                    case 3:
                      // 3: SFRエラーの場合
                      sfrInfo.push({
                        // 戸締り異常地区名(ニックネーム)
                        displayDistrictNickname:
                          this.originalDistrictList[
                            saveDisplayDistrictInfo.sendCustomerNumber +
                              saveDisplayDistrictInfo.securityDistrictNumber
                          ].displayDistrictNickname,
                        // 戸締り異常地区番号
                        districtSplitNumber:
                          this.originalDistrictList[
                            saveDisplayDistrictInfo.sendCustomerNumber +
                              saveDisplayDistrictInfo.securityDistrictNumber
                          ].districtSplitNumber,
                        // 戸締り異常お客様番号
                        customerNumber:
                          this.originalDistrictList[
                            saveDisplayDistrictInfo.sendCustomerNumber +
                              saveDisplayDistrictInfo.securityDistrictNumber
                          ].customerNumber,
                        // ダイアログ内、戸締り異常地区のリンク/ラベル表示設定
                        // 警備エリア有無が存在するand戸締り確認/警報確認権限ありの場合、リンク表示
                        // 上記以外の場合、ラベル表示
                        displayLinkFlag:
                          this.originalDistrictList[
                            saveDisplayDistrictInfo.sendCustomerNumber +
                              saveDisplayDistrictInfo.securityDistrictNumber
                          ].existsSecurityArea &&
                          this.originalDistrictList[
                            saveDisplayDistrictInfo.sendCustomerNumber +
                              saveDisplayDistrictInfo.securityDistrictNumber
                          ].lockUpCheck,
                      });
                      break;
                    case 4:
                      // 4:操作禁止（遷移不可操作）の場合
                      same.push(
                        this.originalDistrictList[
                          saveDisplayDistrictInfo.sendCustomerNumber +
                            saveDisplayDistrictInfo.securityDistrictNumber
                        ].displayDistrictNickname
                      );
                      break;
                    default:
                      // 上記以外のエラーの場合
                      error.push(
                        this.originalDistrictList[
                          saveDisplayDistrictInfo.sendCustomerNumber +
                            saveDisplayDistrictInfo.securityDistrictNumber
                        ].displayDistrictNickname
                      );
                      break;
                  }
                });

                let message = '';
                let district = '';
                let couldNotChangedStatusMessage = '';
                if (complete.length != 0) {
                  if (securityStatus == 'F') {
                    message += this.$vuetify.lang.t(
                      '$vuetify.メッセージ一覧.FECU07トップ画面.C0011',
                      this.saveDisplayDistrictInfoList.length,
                      complete.length
                    );
                    district = '';
                    complete.forEach((displayDistrictNickname, index) => {
                      district += displayDistrictNickname;
                      if (complete.length > index + 1) {
                        district += this.$vuetify.lang.t('$vuetify.FECU07.読点');
                      }
                    });
                    message += this.$vuetify.lang.t(
                      '$vuetify.FECU07.一括警備操作ダイアログ.対象地区',
                      district
                    );
                  } else {
                    message += this.$vuetify.lang.t(
                      '$vuetify.メッセージ一覧.FECU07トップ画面.C0003',
                      this.saveDisplayDistrictInfoList.length,
                      complete.length
                    );
                    district = '';
                    complete.forEach((displayDistrictNickname, index) => {
                      district += displayDistrictNickname;
                      if (complete.length > index + 1) {
                        district += this.$vuetify.lang.t('$vuetify.FECU07.読点');
                      }
                    });
                    message += this.$vuetify.lang.t(
                      '$vuetify.FECU07.一括警備操作ダイアログ.対象地区',
                      district
                    );
                  }
                }
                if (error.length != 0 || sfrInfo.length != 0) {
                  if (message != '') {
                    message += '\n';
                  }
                  if (securityStatus == 'F') {
                    message += this.$vuetify.lang.t(
                      '$vuetify.FECU07.一括警備操作ダイアログ.以下の問題から解除'
                    );
                  } else {
                    message += this.$vuetify.lang.t(
                      '$vuetify.FECU07.一括警備操作ダイアログ.以下の問題'
                    );
                  }
                  if (error.length != 0) {
                    district = '';
                    error.forEach((displayDistrictNickname, index) => {
                      district += displayDistrictNickname;
                      if (error.length > index + 1) {
                        district += this.$vuetify.lang.t('$vuetify.FECU07.読点');
                      }
                    });
                    message += this.$vuetify.lang.t(
                      '$vuetify.FECU07.一括警備操作ダイアログ.警備ユニットエラー',
                      district
                    );
                  }
                }
                if (same.length != 0) {
                  if (message != '') {
                    couldNotChangedStatusMessage += '\n';
                  }
                  district = '';
                  same.forEach((displayDistrictNickname, index) => {
                    district += displayDistrictNickname;
                    if (same.length > index + 1) {
                      district += this.$vuetify.lang.t('$vuetify.FECU07.読点');
                    } else {
                      district += '\n';
                    }
                  });
                  if (securityStatus == 'F') {
                    couldNotChangedStatusMessage += this.$vuetify.lang.t(
                      '$vuetify.FECU07.一括警備操作ダイアログ.警備状態を変更できません_解除',
                      district
                    );
                  } else {
                    couldNotChangedStatusMessage += this.$vuetify.lang.t(
                      '$vuetify.FECU07.一括警備操作ダイアログ.警備状態を変更できません',
                      district
                    );
                  }
                }

                this.callSaveMessageDialog(message, sfrInfo, couldNotChangedStatusMessage);
              }
            } catch (err) {
              this.$store.commit('requestApi/setInterruptionFlag', false);
              this.$errorDialog('$vuetify.メッセージ一覧.FECU07トップ画面.E0002');
              this.$_setLoadingAlsok(false);
            }
          } else {
            if (this.securityUnitExecutionResults.length != 0) {
              this.$store.commit('requestApi/setInterruptionFlag', false);
              this.$_securityUnitExecutionResultsDialog(this.securityUnitExecutionResults);
            } else {
              this.$store.commit('requestApi/setInterruptionFlag', false);
              this.$_securityUnitExecutionResultDialog(-1);
            }
          }
        }
        this.$_setLoadingAlsok(false);
      }
    },
    /**
     * 対象地区選択ダイアログ表示処理
     */
    openLocateDialog: async function () {
      // let param = '/api/top/init';

      // let queries = {
      //   token: sessionStorage.getItem('token'),
      //   terminalInfo: localStorage.getItem('terminalInfo')
      //     ? localStorage.getItem('terminalInfo')
      //     : '',
      // };

      // let method = 'post';
      // await this.APP_CU0701(param, queries, method);
      this.districtList = JSON.parse(JSON.stringify(this.originalDistrictList));
      this.checkBulkSecurityOperationFlg();
      this.selectLocateDialog = true;
      setTimeout(() => {
        this.setPagenationTabIndex();
      }, 50);
    },
    /**
     * チェックボックス確認処理処理(対象地区選択ダイアログ)
     */
    checkBulkSecurityOperationFlg: function () {
      if (this.districtIndexList.length != 0) {
        let selectSecurityDistrict = true;
        this.districtIndexList.forEach((districtIndex) => {
          if (
            this.districtList[districtIndex].bulkSecurityOperationFlg &&
            this.districtList[districtIndex].securityOperation
          ) {
            selectSecurityDistrict = false;
            return true;
          }
        });
        this.disabled.selectSecurityDistrict = selectSecurityDistrict;
      }
    },
    /**
     * クリアボタン押下処理(対象地区選択ダイアログ)
     */
    clickClearButton: function () {
      this.districtIndexList.forEach((districtIndex) => {
        this.districtList[districtIndex].bulkSecurityOperationFlg = false;
      });
      this.checkBulkSecurityOperationFlg();
    },
    /**
     * 全て選択ボタン押下処理(対象地区選択ダイアログ)
     */
    clickAllSelectButton: function () {
      this.districtIndexList.forEach((districtIndex) => {
        this.districtList[districtIndex].bulkSecurityOperationFlg = true;
      });
      this.disabled.selectSecurityDistrict = false;
    },
    /**
     * 適用ボタン押下処理(対象地区選択ダイアログ)
     */
    clickBulkSelectButton: function () {
      this.confirmBulk = true;
    },
    /**
     * はいボタン押下処理(警備設定確認ダイアログ)
     */
    clickYesButton: async function () {
      // APP_CU0703 一括警備対象設定 _登録処理
      await this.APP_CU0703();
      this.displayDistrictMessage();

      this.confirmBulk = false;
      this.selectLocateDialog = false;
    },
    /**
     * キャンセルボタン押下処理(警備設定確認ダイアログ)
     */
    cancelBulkSelectDialog: function () {
      this.confirmBulk = false;
    },
    /**
     * 在宅対象確認ダイアログ表示処理
     */
    openRemoteTagetDialog: async function (i) {
      this.disabled.selectSecurityArea = true;
      this.displayNickName =
        this.districtList[
          this.districtIndexList[this.getDisplayDistrictIndex(i)]
        ].displayDistrictNickname;
      this.settingCustomerNumber =
        this.districtList[this.districtIndexList[this.getDisplayDistrictIndex(i)]].customerNumber;
      this.settingDistrictSplitNumber =
        this.districtList[
          this.districtIndexList[this.getDisplayDistrictIndex(i)]
        ].districtSplitNumber;
      let apiData = await this.APP_CO9910();

      this.remoteDialog = true;
      setTimeout(() => {
        this.setPagenationTabIndex();
      }, 50);

      if (typeof apiData.contentsInfo !== 'undefined') {
        let params = {
          token: sessionStorage.getItem('token'),
          terminalInfo: localStorage.getItem('terminalInfo')
            ? localStorage.getItem('terminalInfo')
            : '',
          sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
          sendCommandKey: apiData.contentsInfo.sendCommandKey,
          apiId: 18,
          alarmType: 0,
          districtSplitNumber: this.settingDistrictSplitNumber,
          securityAreaId: '',
        };
        // APP_CO9915
        await this.APP_CO9910_CO9915(params);
      }
    },
    /**
     * キャンセルボタン押下処理(在宅対象確認ダイアログ)
     */
    clickBulkCancellButton() {
      this.selectLocateDialog = false;
    },
    /**
     * キャンセルボタン押下処理(在宅対象確認ダイアログ)
     */
    clickRemoteCancellButton: function () {
      this.remoteDialog = false;
    },
    /**
     * 適用ボタン押下処理(在宅対象確認ダイアログ)
     */
    clickRemoteSelectllButton: async function () {
      // 在宅対象設定ボタン押下時
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.agreementDialog.設定された内容で登録します',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === false) return; // はい押下時のみ、処理を続行

      let apiData = await this.APP_CO9911();

      if (typeof apiData.contentsInfo !== 'undefined') {
        let params = {
          token: sessionStorage.getItem('token'),
          terminalInfo: localStorage.getItem('terminalInfo')
            ? localStorage.getItem('terminalInfo')
            : '',
          sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
          sendCommandKey: apiData.contentsInfo.sendCommandKey,
          apiId: 19,
          alarmType: 0,
          districtSplitNumber: '',
          securityAreaId: '',
        };
        // APP_CO9915
        await this.APP_CO9911_CO9915(params);
      }
      this.selectLocateDialog = false;
      this.remoteDialog = false;
    },
    /**
     * チェックボックス確認処理処理(在宅対象確認ダイアログ)
     */
    checkMonitoringTargetAtHome: function () {
      if (this.securityAreaList.length != 0) {
        let selectSecurityFlag = true;
        this.securityAreaList.forEach((securityArea) => {
          if (securityArea.isMonitoringTargetAtHome) {
            selectSecurityFlag = false;
            return true;
          }
        });
        this.disabled.selectSecurityArea = selectSecurityFlag;
      }
    },
    /**
     * クリアボタン押下処理(在宅対象確認ダイアログ)
     */
    clickRemoteClearButton: function () {
      for (let i = 0; i <= this.securityAreaList.length; i++) {
        if (this.securityAreaList[i]) {
          this.securityAreaList[i].isMonitoringTargetAtHome = false;
        }
      }
      this.checkMonitoringTargetAtHome();
    },
    /**
     * 全て選択処理(在宅対象確認ダイアログ)
     */
    clickRemoteAllSelect: function () {
      for (let i = 0; i <= this.securityAreaList.length; i++) {
        if (this.securityAreaList[i]) {
          this.securityAreaList[i].isMonitoringTargetAtHome = true;
        }
      }
      this.disabled.selectSecurityArea = false;
    },
    /**
     * チェックボックス押下処理(在宅対象確認ダイアログ)
     */
    setSecurityAreaFlag: function (i) {
      this.securityAreaList[i].isMonitoringTargetAtHome =
        !this.securityAreaList[i].isMonitoringTargetAtHome;
      this.checkMonitoringTargetAtHome();
    },
    /**
     * 在宅対象リストのインデックス番号取得処理
     * @param {*} i 在宅対象確認ダイアログに現在表示されている上から何番目かの数値
     * @returns 在宅対象リストのインデックス番号
     */
    getSecurityAreaIndex: function (i) {
      return i - 1 + this.listRow * (this.securityAreaPage - 1);
    },
    /**
     * チェックボックス押下処理(対象地区選択ダイアログ)
     * @param {*} i 対象地区インデックスリストのインデックス番号
     */
    setDisplayDistrictFlag: function (i) {
      this.districtList[this.districtIndexList[i]].bulkSecurityOperationFlg =
        !this.districtList[this.districtIndexList[i]].bulkSecurityOperationFlg;
      this.checkBulkSecurityOperationFlg();
    },
    /**
     * 対象地区インデックスリストのインデックス番号取得処理
     * @param {*} i 対象地区選択ダイアログに現在表示されている上から何番目かの数値
     * @returns 対象地区インデックスリストのインデックス番号
     */
    getDisplayDistrictIndex: function (i) {
      return i - 1 + this.listRow * (this.displayDistrictPage - 1);
    },
    /**
     * 警備状態表示文字取得処理
     * @param {*} status 警備状態
     * @returns 警備状態表示文字
     */
    getSecurityStatus: function (status) {
      switch (status) {
        case 'N':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.外出ALSOK警備中');
        case 'M':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.在宅ALSOK警備中');
        case 'S':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.外出セルフ警備中');
        case 'L':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.在宅セルフ警備中');
        case 'F':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.警備解除中');
        case 'P':
          return this.$vuetify.lang.t('$vuetify.FECU07.警備状態表示.ユーザ点検');
        default:
          return '';
      }
    },
    /**
     * 対象地区表示文字取得処理
     */
    displayDistrictMessage: function () {
      this.districtMessage = '';

      // 対象地区の表示
      this.districtIndexList.forEach((districtIndex) => {
        if (this.originalDistrictList[districtIndex].bulkSecurityOperationFlg) {
          if (this.districtMessage === '') {
            this.districtMessage = this.originalDistrictList[districtIndex].displayDistrictNickname;
            this.multipleChoice = false;
          } else {
            this.districtMessage = '$vuetify.FECU07.複数選択中';
            this.multipleChoice = true;
          }
        }
      });
    },
    /**
     * 確認ダイアログ表示処理
     * @param {*} text 確認メッセージ
     * @param {*} lockUpAbnormalAreaInfo 戸締り異常の地区情報
     * @param {*} couldNotChangedStatusMessage 警備状態変更不可の文言
     */
    callSaveMessageDialog: async function (
      text,
      lockUpAbnormalAreaInfo = null,
      couldNotChangedStatusMessage = null
    ) {
      this.$informationDialog(
        text,
        false,
        false,
        null,
        lockUpAbnormalAreaInfo,
        couldNotChangedStatusMessage
      );
      // OK
      this.dialog = false;
      this.init();
      // [機能修正管理表No47] 念のため
      this.buttonListUpdate();
    },
    /**
     * PUSH通知確認ダイアログ表示処理
     */
    openMobileAppPushDialog: async function () {
      const nativePushNotification = this.$store.getters['appInfo/getIsPushNotificationAvailable'];

      if (nativePushNotification === '1') {
        // nativeの設定で、PUSH通知設定が許可されている場合はダイアログを表示しない
        return;
      }

      // nativeの設定で、PUSH通知設定が許可されていない場合、処理を続行
      let displayDistrictInfo = [];
      this.districtIndexList.forEach((districtIndex) => {
        displayDistrictInfo.push({
          customerNumber: this.originalDistrictList[districtIndex].customerNumber,
          districtSplitNumber: this.originalDistrictList[districtIndex].districtSplitNumber,
        });
      });

      let promiseList = [];
      displayDistrictInfo.forEach((displayDistrict) => {
        promiseList.push(
          // pushNotificationDeliveryInfoListをBooleanで更新
          this.APP_CU2201(displayDistrict.customerNumber, displayDistrict.districtSplitNumber)
        );
      });
      if (promiseList.length != 0) {
        await Promise.all(promiseList); // APP_CU2201を並列実行
      }

      // 一つでもPUSH通知設定が設定されている場合, 確認ダイアログを開く
      if (this.pushNotificationDeliveryInfoList.includes(true)) {
        this.pushNotificationSettingDialog = true;
      }
    },
    /**
     * 設定画面を開くボタン押下処理(PUSH通知確認ダイアログ)
     */
    openNativeSettingApp: async function () {
      this.pushNotificationSettingDialog = false;
      const targetPage = 1; // 0: 設定アプリのTOP画面, 1: PUSH通知の許可/禁止の切り替え
      NativeApi.openSettingApp(targetPage); // Native部で設定アプリを起動する
    },
    /**
     * このまま使用するボタン押下処理(PUSH通知確認ダイアログ)
     */
    closePushNotificationDialog: async function () {
      this.pushNotificationSettingDialog = false;
    },
    /**
     * 初期表示(APP_CU0701)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU0701: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     newsInfo: [
            //       {
            //         newsTitle: "メンテナンスのお知らせ",
            //         newsContent:
            //           "サーバーメンテナンスのため一時的にアプリ利用ができなくなります。警備機器ホームアルソックXS をご利用のお客様は ALSOKホームページをご確認ください。",
            //         newsDateTime: "2020-2-2 12:00",
            //       },
            //       {
            //         newsTitle: "バージョンアップのお知らせ",
            //         newsContent:
            //           "アプリバージョン ver2.0.3を公開予定です。古いアプリは利用できなくなります。",
            //         newsDateTime: "2020-1-1 08:00",
            //       },
            //     ],
            //     displayDistrictInfo: [
            //       {
            //         displayDistrictNickname: "displayDistrictNickname1",
            //         customerNumber: "customerNumber1",
            //         districtSplitNumber: "districtSplitNumber1",
            //         bulkSecurityOperationFlg: true,
            //         targetAtHomeSetting: true,
            //         modified: "2020-1-1 08:00",
            //       },
            //       {
            //         displayDistrictNickname: "displayDistrictNickname2",
            //         customerNumber: "customerNumber2",
            //         districtSplitNumber: "districtSplitNumber2",
            //         bulkSecurityOperationFlg: false,
            //         targetAtHomeSetting: true,
            //         modified: "2020-1-1 08:00",
            //       },
            //       {
            //         displayDistrictNickname: "displayDistrictNickname3",
            //         customerNumber: "customerNumber3",
            //         districtSplitNumber: "districtSplitNumber3",
            //         bulkSecurityOperationFlg: false,
            //         targetAtHomeSetting: true,
            //         modified: "2020-1-1 08:00",
            //       },
            //       {
            //         displayDistrictNickname: "displayDistrictNickname4",
            //         customerNumber: "customerNumber4",
            //         districtSplitNumber: "districtSplitNumber4",
            //         bulkSecurityOperationFlg: false,
            //         targetAtHomeSetting: false,
            //         modified: "2020-1-1 08:00",
            //       },
            //       {
            //         displayDistrictNickname: "displayDistrictNickname5",
            //         customerNumber: "customerNumber5",
            //         districtSplitNumber: "districtSplitNumber5",
            //         bulkSecurityOperationFlg: false,
            //         targetAtHomeSetting: true,
            //         modified: "2020-1-1 08:00",
            //       },
            //     ],
            //     isTopCameraActive: true,
            //     isTopHomeSecurityActive: true,
            //     unitCommandInfo: [
            //       {
            //         sendCustomerNumber: "sendCustomerNumber1",
            //         sendCommandKey: "sendCommandKey1",
            //       },
            //       {
            //         sendCustomerNumber: "sendCustomerNumber2",
            //         sendCommandKey: "sendCommandKey2",
            //       },
            //       {
            //         sendCustomerNumber: "sendCustomerNumber3",
            //         sendCommandKey: "sendCommandKey3",
            //       },
            //     ],
            //   },
            // };

            if (apiData.contentsInfo) {
              // ALSOKからのお知らせ
              this.newsInfo = [];
              await apiData.contentsInfo.newsInfo.forEach((element, index) => {
                const date = TimeParser(element.newsDateTime);
                this.newsInfo.push({
                  id: index,
                  newsTitle: element.newsTitle,
                  newsContent: element.newsContent,
                  newsDateTime: {
                    year: date.year,
                    month: date.month,
                    day: date.day,
                    hour: date.hour,
                    minutes: date.minutes,
                  },
                });
              });
              let aTags = document.querySelectorAll('.news-list-area a');
              for (let aTag of aTags) {
                aTag.onclick = function (e) {
                  e.preventDefault();
                  NativeApi.openBrowserApp(aTag.href);
                };
              }

              // 簡易サービスボタン、サービス追加ボタンは初回のみ作成
              if (!this.serviceButtonInitFlag) {
                let buttonId = this.buttonList.length;
                if (apiData.contentsInfo.simpleServiceInfo) {
                  apiData.contentsInfo.simpleServiceInfo.forEach((element) => {
                    this.simpleServiceInfoList.push({
                      id: String(++buttonId),
                      serviceName: element.serviceName,
                      serviceNameEN: element.serviceNameEN,
                      url: element.url,
                      urlIOS: element.urlIOS,
                      iconPath: element.iconPath,
                    });
                  });

                  //簡易サービスボタン
                  this.simpleServiceInfoList.forEach((element) => {
                    this.buttonList.push({
                      id: element.id,
                      isShow: true,
                      isHidden: false,
                      divclass: 'icons',
                      linenum: 1,
                      line1: '',
                      line2: '',
                      viewBox: '0 0 40 40',
                      xlink:
                        `${window.location.protocol + '//' + window.location.host}/` +
                        '/hs-static/simple_service/' +
                        element.iconPath +
                        '#simple_service',
                      click: null,
                      url: element.url,
                      urlIOS: element.urlIOS,
                      serviceName: element.serviceName,
                      serviceNameEN: element.serviceNameEN,
                    });
                  });

                  // 簡易サービスボタンのボタン名を設定
                  this.changeLang(this.$vuetify.lang.current);
                }
                // サービス追加ボタンは末尾
                this.buttonList.push({
                  id: String(++buttonId),
                  isShow: true,
                  isHidden: false,
                  divclass: 'icons',
                  linenum: 1,
                  line1: '$vuetify.FECU07.サービス追加',
                  line2: '',
                  viewBox: '0 0 30.5 30.5',
                  xlink: require('../../assets/images/top/sp-service.svg') + '#service',
                  click: null,
                });

                this.serviceButtonInitFlag = true;
              }

              // ホームセキュリティ表示フラグ（Navのホームセキュリティボタンも表示制御する。）
              this.$store.state.isTopHomeSecurityActive =
                apiData.contentsInfo.isTopHomeSecurityActive;

              // カメラ表示フラグ（Navのカメラボタンも表示制御する。）
              this.$store.state.isTopCameraActive = apiData.contentsInfo.isTopCameraActive;

              // 警備中存在フラグ、セルフ契約存在フラグ、セルフ固定フラグを初期化
              this.existsSecurityOnGuardFlag = false;
              this.existsSecuritySelfPlanFlag = false;
              this.dontSelectFlag = false;

              // no good
              // [機能修正管理表No47] $storeを更新したらボタンも明示的に更新(本当はWatchで監視したい)
              this.buttonListUpdate();
              let districtIndexList = [];
              let districtList = {};
              let tmpAuth = this.tmpAuthority;
              this.selectSecurityAreaList = [];
              apiData.contentsInfo.displayDistrictInfo.forEach((displayDistrict) => {
                // 重複を防ぐために顧客番号を結合
                // districtIndexList.push(
                //   displayDistrict.customerNumber + displayDistrict.districtSplitNumber
                // );
                districtList[displayDistrict.customerNumber + displayDistrict.districtSplitNumber] =
                  {
                    displayDistrictNickname: displayDistrict.displayDistrictNickname,
                    customerNumber: displayDistrict.customerNumber,
                    districtSplitNumber: displayDistrict.districtSplitNumber,
                    bulkSecurityOperationFlg: displayDistrict.bulkSecurityOperationFlg,
                    targetAtHomeSetting: displayDistrict.targetAtHomeSetting,
                    securityStatus: '',
                    securityOperation:
                      tmpAuth[displayDistrict.customerNumber + displayDistrict.districtSplitNumber]
                        .securityOperation,
                    existsSecurityArea:
                      tmpAuth[displayDistrict.customerNumber + displayDistrict.districtSplitNumber]
                        .existsSecurityArea,
                    lockUpCheck:
                      tmpAuth[displayDistrict.customerNumber + displayDistrict.districtSplitNumber]
                        .lockUpCheck,
                    modified: displayDistrict.modified,
                  };

                if (displayDistrict.bulkSecurityOperationFlg) {
                  this.selectSecurityAreaList.push(
                    displayDistrict.customerNumber + displayDistrict.districtSplitNumber
                  );
                  if (
                    displayDistrict.usagePlan !=
                    CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN
                  ) {
                    // 選択中の地区にオンライン監視プラン以外が存在する場合
                    this.dontSelectFlag = true;
                  }
                  if (
                    displayDistrict.usagePlan ==
                      CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN ||
                    displayDistrict.usagePlan ==
                      CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE
                  ) {
                    // 選択中の地区にセルフ契約が存在する場合
                    this.existsSecuritySelfPlanFlag = true;
                  }
                }
              });

              // sort by districtNickname
              let sortedDistrictList = {};
              Object.keys(districtList)
                .sort(function (a, b) {
                  return districtList[a].displayDistrictNickname.localeCompare(
                    districtList[b].displayDistrictNickname,
                    'ja'
                  ); // sort by japanese character
                })
                .forEach(function (key) {
                  sortedDistrictList[key] = districtList[key];
                  // 重複を防ぐために顧客番号を結合
                  districtIndexList.push(key); // push to array follow by order of districtNickname
                });

              this.districtIndexList = districtIndexList;
              this.originalDistrictList = sortedDistrictList;
              this.districtList = JSON.parse(JSON.stringify(this.originalDistrictList));

              this.displayDistrictPage = 1;
              this.displayDistrictPageLength =
                Math.floor((this.districtIndexList.length - 1) / this.listRow) + 1;
            }
          },
          (error /* eslint-disable-line */) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      // console.log("APP_CU0701>>>", apiData);
      return apiData;
    },
    /**
     * APP_CU0701に対する警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @param {*} time 送信を待つ時間
     * @returns レスポンス
     */
    APP_CU0701_CO9915: async function (params, time) {
      // テストコード
      // APP_CU0701_CO9915: async function (params, index) {
      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      await sleep(time);
      this.selectSecurityStatus = '';
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          // サンプルデータ
          // switch (index) {
          //   case 0:
          //     apiData = {
          //       contentsInfo: {
          //         securityUnitExecutionResult: 0,
          //         commandExecutionResult: {
          //           app_cu0701: {
          //             securityDistrictInfo: [
          //               {
          //                 securityDistrictNumber: "districtSplitNumber1",
          //                 securityStatus: "N",
          //               },
          //               {
          //                 securityDistrictNumber: "districtSplitNumber2",
          //                 securityStatus: "M",
          //               },
          //             ],
          //           },
          //         },
          //       },
          //     };
          //     break;
          //   case 1:
          //     apiData = {
          //       contentsInfo: {
          //         securityUnitExecutionResult: 0,
          //         commandExecutionResult: {
          //           app_cu0701: {
          //             securityDistrictInfo: [
          //               {
          //                 securityDistrictNumber: "districtSplitNumber3",
          //                 securityStatus: "S",
          //               },
          //             ],
          //           },
          //         },
          //       },
          //     };
          //     break;
          //   case 2:
          //     apiData = {
          //       contentsInfo: {
          //         securityUnitExecutionResult: 0,
          //         commandExecutionResult: {
          //           app_cu0701: {
          //             securityDistrictInfo: [
          //               {
          //                 securityDistrictNumber: "districtSplitNumber4",
          //                 securityStatus: "L",
          //               },
          //               {
          //                 securityDistrictNumber: "districtSplitNumber5",
          //                 securityStatus: "F",
          //               },
          //             ],
          //           },
          //         },
          //       },
          //     };
          //     break;
          // }

          if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult == 0
          ) {
            // コマンド情報受信
            this.connectionSucceededSecurityUnitCustomerNumberList.push(params.sendCustomerNumber);
            // app_cu0701 の結果を検証
            apiData.contentsInfo.commandExecutionResult.app_cu0701.securityStatusInfo.forEach(
              (securityStatus) => {
                if (
                  typeof this.originalDistrictList[
                    params.sendCustomerNumber + securityStatus.securityDistrictNumber
                  ] !== 'undefined'
                ) {
                  // 警備状態を保存
                  this.originalDistrictList[
                    params.sendCustomerNumber + securityStatus.securityDistrictNumber
                  ].securityStatus = securityStatus.securityStatus;

                  if (
                    this.originalDistrictList[
                      params.sendCustomerNumber + securityStatus.securityDistrictNumber
                    ].bulkSecurityOperationFlg &&
                    this.originalDistrictList[
                      params.sendCustomerNumber + securityStatus.securityDistrictNumber
                    ].securityOperation
                  ) {
                    this.selectSecurityDistrictCount += 1;
                    if (this.selectSecurityStatus == '') {
                      // retrieve only first security status when there are multi security status
                      this.selectSecurityStatus = securityStatus.securityStatus;
                    }
                  }

                  if (
                    this.originalDistrictList[
                      params.sendCustomerNumber + securityStatus.securityDistrictNumber
                    ].bulkSecurityOperationFlg &&
                    (securityStatus.securityStatus === 'N' || // 外出 ALSOK 警備中
                      securityStatus.securityStatus === 'M' || // 在宅 ALSOK 警備中
                      securityStatus.securityStatus === 'S' || // 外出セルフ警備中
                      securityStatus.securityStatus === 'L') // 在宅セルフ警備中
                  ) {
                    // 選択中の地区に警備中が１つでもある
                    this.existsSecurityOnGuardFlag = true;
                  }
                }
              }
            );
          } else if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult != 0
          ) {
            if (apiData.contentsInfo.securityUnitExecutionResult != -1) {
              this.securityUnitExecutionResults.push(
                apiData.contentsInfo.securityUnitExecutionResult
              );
            }
            if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
              this.$store.commit('requestApi/setInterruptionFlag', true);
            }
          } else if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
            this.$store.commit('requestApi/setInterruptionFlag', true);
          }
        });

      // console.log("APP_CO9915>>>", apiData);
      return apiData;
    },
    /**
     * 一括警備設定(APP_CU0702)
     * @param {*} securityStatus 警備状態
     * @returns レスポンス
     */
    APP_CU0702: async function (securityStatus) {
      let param = '/api/top/bulkSecuritySettings';
      // let param = "post

      this.saveDisplayDistrictInfoList = [];
      let displayDistrictInfo = [];
      this.districtIndexList.forEach((districtIndex) => {
        if (
          this.originalDistrictList[districtIndex].securityOperation &&
          this.originalDistrictList[districtIndex].bulkSecurityOperationFlg
        ) {
          displayDistrictInfo.push({
            customerNumber: this.originalDistrictList[districtIndex].customerNumber,
            districtSplitNumber: this.originalDistrictList[districtIndex].districtSplitNumber,
          });
        }
      });

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        displayDistrictInfo: displayDistrictInfo,
        securityStatus: securityStatus,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     unitCommandInfo: [
            //       {
            //         sendCustomerNumber: "sendCustomerNumber1",
            //         sendCommandKey: "sendCommandKey1",
            //       },
            //       {
            //         sendCustomerNumber: "sendCustomerNumber2",
            //         sendCommandKey: "sendCommandKey2",
            //       },
            //     ],
            //   },
            // };
          },
          (error /* eslint-disable-line */) => {
            if (error.response.status == '400') {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU07トップ画面.E0004');
            } else {
              // 異常系の処理
              this.$_abnormality(error.response.status);
            }
          }
        );
      // console.log("APP_CU0702>>>", apiData);
      return apiData;
    },
    /**
     * APP_CU0702に対する警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @param {*} sendCustomerNumber お客様番号
     * @returns レスポンス
     */
    APP_CU0702_CO9915: async function (params, sendCustomerNumber) {
      // テストコード
      // APP_CU0702_CO9915: async function (params, index) {

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          // サンプルデータ
          // switch (index) {
          //   case 0:
          //     apiData = {
          //       contentsInfo: {
          //         securityUnitExecutionResult: 0,
          //         commandExecutionResult: {
          //           app_cu0702: {
          //             securityDistrictInfo: [
          //               {
          //                 securityDistrictNumber: "districtSplitNumber1",
          //                 securityStatusChangeResult: 0,
          //               },
          //               {
          //                 securityDistrictNumber: "districtSplitNumber2",
          //                 securityStatusChangeResult: 3,
          //               },
          //             ],
          //           },
          //         },
          //       },
          //     };
          //     break;
          //   case 1:
          //     apiData = {
          //       contentsInfo: {
          //         securityUnitExecutionResult: 0,
          //         commandExecutionResult: {
          //           app_cu0702: {
          //             securityDistrictInfo: [
          //               {
          //                 securityDistrictNumber: "districtSplitNumber3",
          //                 securityStatusChangeResult: 4,
          //               },
          //             ],
          //           },
          //         },
          //       },
          //     };
          //     break;
          // }
          if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult == 0
          ) {
            apiData.contentsInfo.commandExecutionResult.app_cu0702.securityDistrictInfo.forEach(
              (securityDistrict) => {
                this.saveDisplayDistrictInfoList.push({
                  securityDistrictNumber: securityDistrict.securityDistrictNumber,
                  securityStatusChangeResult: securityDistrict.securityStatusChangeResult,
                  sendCustomerNumber: sendCustomerNumber,
                });
              }
            );
          } else if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult != 0
          ) {
            if (apiData.contentsInfo.securityUnitExecutionResult != -1) {
              this.securityUnitExecutionResults.push(
                apiData.contentsInfo.securityUnitExecutionResult
              );
            }
            if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
              this.$store.commit('requestApi/setInterruptionFlag', true);
            }
          } else if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
            this.$store.commit('requestApi/setInterruptionFlag', true);
          }
        });

      // console.log("APP_CO9915>>>", apiData);
      return apiData;
    },
    /**
     * 一括警備対象設定(APP_CU0703)
     */
    APP_CU0703: async function () {
      this.$_setLoading(true);

      let param = '/api/top/bulkSecurityTargetSettings';
      // let param = "post";

      let displayDistrictInfo = [];
      this.districtIndexList.forEach((districtIndex) => {
        if (this.districtList[districtIndex].securityOperation) {
          // リロードせずに再度ダイアログを開く場合もあるので更新する
          this.originalDistrictList[districtIndex].bulkSecurityOperationFlg =
            this.districtList[districtIndex].bulkSecurityOperationFlg;

          displayDistrictInfo.push({
            customerNumber: this.districtList[districtIndex].customerNumber,
            districtSplitNumber: this.districtList[districtIndex].districtSplitNumber,
            bulkSecurityOperationFlg: this.districtList[districtIndex].bulkSecurityOperationFlg,
            modified: this.districtList[districtIndex].modified,
          });
        }
      });

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        displayDistrictInfo: displayDistrictInfo,
      };

      let method = 'post';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // 処理なし
            this.$_setLoading(false);
            this.init();
            // [機能修正管理表No47] 念のため
            this.buttonListUpdate();
          },
          (error /* eslint-disable-line */) => {
            this.$_setLoading(false);
            if (error.response.status == '400') {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU07トップ画面.E0005');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        );
      // console.log("APP_CU0703>>>", apiData);
    },
    /**
     * 警備エリア・在宅対象情報取得(APP_CO9910)
     * @returns レスポンス
     */
    APP_CO9910: async function () {
      this.$_setLoading(true);
      let param = '/api/common/getSecurityArea';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.settingCustomerNumber,
        districtSplitNumber: this.settingDistrictSplitNumber,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     sendCustomerNumber: "sendCustomerNumber",
            //     sendCommandKey: "sendCommandKey",
            //   },
            // };
          },
          (error /* eslint-disable-line */) => {
            if (error.response.status == '400') {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU07トップ画面.E0006');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      // console.log("APP_CO9910>>>", apiData);
      return apiData;
    },
    /**
     * APP_CO9910に対する警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @returns レスポンス
     */
    APP_CO9910_CO9915: async function (params) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_co9910: {
          //         securityAreaList: [
          //           {
          //             securityAreaId: "1",
          //             securityAreaName: "玄関",
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: "2",
          //             securityAreaName: "キッチン",
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: "3",
          //             securityAreaName: "リビング",
          //             isMonitoringTargetAtHome: false,
          //           },
          //           {
          //             securityAreaId: "4",
          //             securityAreaName: "寝室",
          //             isMonitoringTargetAtHome: false,
          //           },
          //           {
          //             securityAreaId: "5",
          //             securityAreaName: "ベランダ",
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: "6",
          //             securityAreaName: "子供部屋",
          //             isMonitoringTargetAtHome: false,
          //           },
          //           {
          //             securityAreaId: "7",
          //             securityAreaName: "書斎",
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: "8",
          //             securityAreaName: "倉庫",
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: "9",
          //             securityAreaName: "庭",
          //             isMonitoringTargetAtHome: false,
          //           },
          //           {
          //             securityAreaId: "10",
          //             securityAreaName: "車庫",
          //             isMonitoringTargetAtHome: false,
          //           },
          //           {
          //             securityAreaId: "11",
          //             securityAreaName: "屋根裏",
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: "12",
          //             securityAreaName: "廊下",
          //             isMonitoringTargetAtHome: false,
          //           },
          //         ],
          //       },
          //     },
          //   },
          // };

          if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult == 0
          ) {
            this.securityAreaList =
              apiData.contentsInfo.commandExecutionResult.app_co9910.securityAreaList;
            this.securityAreaPage = 1;
            this.securityAreaPageLength =
              Math.floor((this.securityAreaList.length - 1) / this.listRow) + 1;
            this.checkMonitoringTargetAtHome();
          } else {
            if (apiData.contentsInfo.securityUnitExecutionResult === -1) {
              // disabled button 適用 when there is no security area
              this.disabled.selectSecurityArea = true;
            }
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });

      // console.log("APP_CO9915>>>", apiData);
      return apiData;
    },
    /**
     * 在宅対象情報更新(APP_CO9911)
     * @returns レスポンス
     */
    APP_CO9911: async function () {
      this.$_setLoading(true);

      let param = '/api/common/updateMonitoringTargetsAtHome';
      // let param = "post";

      let securityAreaList = [];
      this.securityAreaList.forEach(function (securityArea) {
        securityAreaList.push({
          securityAreaId: securityArea.securityAreaId,
          isMonitoringTargetAtHome: securityArea.isMonitoringTargetAtHome,
        });
      });

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.settingCustomerNumber,
        districtSplitNumber: this.settingDistrictSplitNumber,
        securityAreaList: securityAreaList,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     sendCustomerNumber: "sendCustomerNumber",
            //     sendCommandKey: "sendCommandKey",
            //   },
            // };
          },
          (error /* eslint-disable-line */) => {
            if (error.response.status == '400') {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU07トップ画面.E0007');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      // console.log("APP_CO9911>>>", apiData);
      return apiData;
    },
    /**
     * APP_CO9911に対する警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @returns レスポンス
     */
    APP_CO9911_CO9915: async function (params) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //   },
          // };

          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            this.$informationDialog('$vuetify.メッセージ一覧.FECU07トップ画面.C0008');
          } else {
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });

      // console.log("APP_CO9915>>>", apiData);
      return apiData;
    },
    /**
     * ユーザー権限一覧取得(APP_CU9916)
     */
    async APP_CO9916() {
      this.$_setLoading(true);
      let param = '/api/common/getRoleList';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

          apiData.contentsInfo.displayDistrictInfoList.map((district) => {
            this.tmpAuthority[district.customerNumber + district.districtSplitNumber] =
              district.userAuthority;
            this.tmpAuthority[
              district.customerNumber + district.districtSplitNumber
            ].existsSecurityArea = district.existsSecurityArea;
          });

          if (typeof apiData.contentsInfo !== 'undefined') {
            this.disabled.existsSecurityArea9916 = true;
            let userAuthority = false;
            this.existsSecurityAreaList = [];
            apiData.contentsInfo.displayDistrictInfoList.forEach((displayDistrictInfo) => {
              this.needPushNotificationPermissionCount +=
                displayDistrictInfo.canUsePushNotification +
                displayDistrictInfo.canUseWatchOverFunction;
              if (displayDistrictInfo.userAuthority.securityOperation) {
                this.disabled.securityOperation9916 = false; // 権限あり
              }
              if (
                displayDistrictInfo.existsSecurityArea &&
                displayDistrictInfo.userAuthority.securityOperation
              ) {
                this.existsSecurityAreaList.push(
                  displayDistrictInfo.customerNumber + displayDistrictInfo.districtSplitNumber
                );
              }

              if (!userAuthority) {
                if (
                  displayDistrictInfo.userAuthority.securityOperation == true ||
                  displayDistrictInfo.userAuthority.rushOrder == true ||
                  displayDistrictInfo.userAuthority.notificationHistory == true ||
                  displayDistrictInfo.userAuthority.deviceContorol == true ||
                  displayDistrictInfo.userAuthority.contact == true ||
                  displayDistrictInfo.userAuthority.nicknameSetting == true ||
                  displayDistrictInfo.userAuthority.IDCardKeyInfoSetting == true ||
                  displayDistrictInfo.userAuthority.watchOverInfoDeliverySetting == true ||
                  displayDistrictInfo.userAuthority.lockUpCheck == true ||
                  displayDistrictInfo.userAuthority.targetAtHomeSetting == true ||
                  displayDistrictInfo.userAuthority.userManagement == true ||
                  displayDistrictInfo.userAuthority.emergencyContact == true
                ) {
                  userAuthority = true;
                }
              }
            });

            if (!userAuthority || apiData.contentsInfo.displayDistrictInfoList.length == 0) {
              // APP_9916のレスポンスの対象地区情報一覧で、ユーザー権限が全てfalseの場合、ホームセキュリティボタンを非表示にする。
              this.$store.state.disableHomeSecurityActive = true;
            } else {
              // APP_9916のレスポンスの対象地区情報一覧で、ユーザー権限に一つでもtrueがある場合、ホームセキュリティボタンを表示する。
              this.$store.state.disableHomeSecurityActive = false;
            }

            if (apiData.contentsInfo.displayDistrictInfoList.length == 1) {
              this.$store.commit('setOneDistrictCustomerNumber', {
                oneDistrictCustomerNumber:
                  apiData.contentsInfo.displayDistrictInfoList[0].customerNumber,
              });
              this.$store.commit('setOneDistrictSplitNumber', {
                oneDistrictSplitNumber:
                  apiData.contentsInfo.displayDistrictInfoList[0].districtSplitNumber,
              });
              this.$store.state.districtOneCountFlag = true;
            } else {
              this.$store.state.districtOneCountFlag = false;
            }

            let userAuthorityCamera = false;
            apiData.contentsInfo.cameraInfoList.forEach((cameraInfo) => {
              this.needPushNotificationPermissionCount += cameraInfo.canUsePushNotification;
              if (
                cameraInfo.userAuthority.anticrimeCameraVideos == true ||
                cameraInfo.userAuthority.rushOrder == true ||
                cameraInfo.userAuthority.notificationHistory == true ||
                cameraInfo.userAuthority.contact == true ||
                cameraInfo.userAuthority.nicknameSetting == true ||
                cameraInfo.userAuthority.userManagement == true ||
                cameraInfo.userAuthority.emergencyContact == true
              ) {
                userAuthorityCamera = true;
                return true;
              }
            });

            if (!userAuthorityCamera || apiData.contentsInfo.cameraInfoList.length == 0) {
              // APP_9916のレスポンスのカメラ情報一覧で、ユーザー権限が全てfalseの場合、カメラボタンを非表示にする。
              this.$store.state.disableCamera = true;
            } else {
              // APP_9916のレスポンスのカメラ情報一覧で、ユーザー権限に一つでもtrueがある場合、カメラボタンを表示する。
              this.$store.state.disableCamera = false;
            }

            if (apiData.contentsInfo.cameraInfoList.length == 1) {
              this.$store.commit('setOneCameraCustomerNumber', {
                oneCameraCustomerNumber: apiData.contentsInfo.cameraInfoList[0].customerNumber,
              });
              this.$store.commit('setOneCameraDeviceID', {
                oneCameraDeviceID: apiData.contentsInfo.cameraInfoList[0].deviceID,
              });
              this.$store.state.cameraOneCountFlag = true;
            } else {
              this.$store.state.cameraOneCountFlag = false;
            }

            this.displayDistrictInfoList = apiData.contentsInfo.displayDistrictInfoList;
            this.cameraInfoList = apiData.contentsInfo.cameraInfoList;
          }
        })
        .catch((error) => {
          this.$_abnormality(error.response.status);
        })
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * 初期表示(APP_CU2201)
     * @param {*} customerNumber お客様番号
     * @param {*} districtSplitNumber 地区番号
     */
    APP_CU2201: async function (customerNumber, districtSplitNumber) {
      this.$_setLoading(true);

      // 正常系を確認したい場合は下記のコメントを解除する
      let param = '/api/displayDistrictNotificationDeliverySetting/init';
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: customerNumber,
        districtSplitNumber: districtSplitNumber,
      };

      let method = 'get';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: [
            //       {
            //         displayDistrictFacilityName: "自宅",
            //         usagePlanId: 0,
            //         customerNumber: "51-1234567",
            //         districtSplitName: "地区名1234",
            //         districtSplitNumber: "0001",
            //       },
            //       {
            //         displayDistrictFacilityName: "自宅",
            //         usagePlanId: 0,
            //         customerNumber: "51-1234567",
            //         districtSplitName: "地区名1234",
            //         districtSplitNumber: "0001",
            //       },
            //     ],
            //     pushNotificationDeliveryInfo: {
            //       isNotification: true,
            //       isSecurityOperateNotification: true,
            //       isIntrusionNotification: true,
            //       isFireNotification: true,
            //       isFireRecoveryNotification: true,
            //       isGasNotification: true,
            //       isGasRecoveryNotification: true,
            //       isEmergencyNotification: true,
            //       isEmergencyRecoveryNotification: true,
            //       isLifeRhythmfireNotification: true,
            //       isLifeRhythmfireRecoveryNotification: true,
            //       isEquipmentNotification: true,
            //       isEquipmentRecoveryNotification: true,
            //       isLowBatteryNotification: true,
            //       isLowBatteryRecoveryNotification: true,
            //       isEquipmentErrorNotification: true,
            //       isEquipmentErrorRecoveryNotification: true,
            //       isNewsNotification: true,
            //     },
            //     mailNotificationDeliveryInfo: {
            //       isNotification: true,
            //       isSecurityOperateNotification: true,
            //       isIntrusionNotification: true,
            //       isFireNotification: true,
            //       isFireRecoveryNotification: true,
            //       isGasNotification: true,
            //       isGasRecoveryNotification: true,
            //       isEmergencyNotification: true,
            //       isEmergencyRecoveryNotification: true,
            //       isLifeRhythmfireNotification: true,
            //       isLifeRhythmfireRecoveryNotification: true,
            //       isEquipmentNotification: true,
            //       isEquipmentRecoveryNotification: true,
            //       isLowBatteryNotification: true,
            //       isLowBatteryRecoveryNotification: true,
            //       isEquipmentErrorNotification: true,
            //       isEquipmentErrorRecoveryNotification: true,
            //       isNewsNotification: true,
            //     },
            //     modified: "2022-05-16 12:00:00",
            //   },
            // };

            this.pushNotificationDeliveryInfoList = [
              ...this.pushNotificationDeliveryInfoList,
              apiData.contentsInfo.pushNotificationDeliveryInfo.isNotification,
            ];
          },
          (error /* eslint-disable-line */) => {
            // 異常系の処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU2201>>>", apiData);
    },
    /**
     * ページ変更処理(対象地区選択ダイアログ)
     * @param {*} page ページ番号
     */
    changeDisplayDistrictPage(page) {
      if (page === 1) {
        this.totalVisiblePageItem = 3;
      } else if (page >= 2 && page <= 3) {
        // show next 5 page when page is from 2 to 6
        this.totalVisiblePageItem = page + 3;
      } else if (
        page >= this.displayDistrictPageLength - 3 &&
        page <= this.displayDistrictPageLength
      ) {
        // show prev 5 page when page is from max-5 to max
        this.totalVisiblePageItem = this.displayDistrictPageLength + 0 - page;
      } else {
        this.totalVisiblePageItem = 3;
      }
      setTimeout(() => {
        this.setPagenationTabIndex();
      }, 50);
    },
    /**
     * ページ変更処理(在宅対象確認ダイアログ)
     * @param {*} page ページ番号
     */
    changeSecurityAreaPage(page) {
      if (page === 1) {
        this.totalVisiblePageItem = 3;
      } else if (page >= 2 && page <= 3) {
        // show next 5 page when page is from 2 to 6
        this.totalVisiblePageItem = page + 3;
      } else if (page >= this.securityAreaPageLength - 3 && page <= this.securityAreaPageLength) {
        // show prev 5 page when page is from max-5 to max
        this.totalVisiblePageItem = this.securityAreaPageLength + 0 - page;
      } else {
        this.totalVisiblePageItem = 3;
      }
      setTimeout(() => {
        this.setPagenationTabIndex();
      }, 50);
    },
    /**
     * PUSH通知ダイアログ表示処理
     */
    async checkAndShowRequestPushNotificationPermissionDialog() {
      if (
        this.needPushNotificationPermissionCount > 0 &&
        this.$store.getters['appInfo/getIsPushNotificationAvailable'] === '-1'
      ) {
        const result = await this.$agreementDialog(
          '$vuetify.requirePushNotificationPermission.title',
          '$vuetify.requirePushNotificationPermission.content',
          '$vuetify.requirePushNotificationPermission.openSetting',
          '$vuetify.requirePushNotificationPermission.keepStable',
          {
            contentClass: 'login-push-notification-dialog',
            cancelButtonType: 1,
            okButtonType: 4,
          }
        );

        if (!result) {
          NativeApi.openSettingApp(1);
        }
      }
    },
    /**
     * ページネーションのタブインデックス初期化処理
     */
    setPagenationTabIndex() {
      const elements = document.getElementsByClassName('page-number');
      for (let element of elements) {
        element.tabIndex = -1;
      }
    },
    /**
     * アップセルリンクを別タブで開く
     */
    async upsellLink() {
      if (this.$isMobileApp) {
        NativeApi.openBrowserApp(this.upsellUrl);
      } else {
        window.open(this.upsellUrl, '_blank');
      }
    },
    /**
     * 簡易サービスボタン押下
     */
    returnSimpleService(buttonInfo) {
      const userAgent = navigator.userAgent;

      if (this.$isMobile) {
        if (this.$isMobileApp && /android/i.test(userAgent)) {
          // アプリ/android
          NativeApi.openBrowserApp(buttonInfo.url);
        } else if (this.$isMobileApp) {
          // アプリ/iOS
          NativeApi.openBrowserApp(buttonInfo.urlIOS);
        } else if (!this.$isMobileApp && /android/i.test(userAgent)) {
          // Webアプリ/android
          window.open(buttonInfo.url, '_blank');
        } else {
          // Webアプリ/iOS
          window.open(buttonInfo.urlIOS, '_blank');
        }
      } else if (/mac/i.test(userAgent)) {
        // PC/Mac
        window.open(buttonInfo.urlIOS, '_blank');
      } else {
        // PC/Mac以外
        window.open(buttonInfo.url, '_blank');
      }
    },
    /**
     * ボタン更新
     */
    buttonListUpdate() {
      this.buttonLine = [];
      //no good!!!
      //とりあえず、今は、順番固定なので
      this.buttonList[0].isShow =
        this.$store.state.isTopHomeSecurityActive && !this.$store.state.disableHomeSecurityActive;
      this.buttonList[1].isShow =
        this.$store.state.isTopCameraActive && !this.$store.state.disableCamera;
      this.buttonList[0].click = this.returnDisplayDistrict;
      this.buttonList[1].click = this.returnCamera;
      this.buttonList[2].click = this.returnContactUsHouseSupport;
      this.buttonList[3].click = this.upsellLink;

      let idNum = 4;
      //簡易サービスボタン
      this.simpleServiceInfoList.forEach(() => {
        this.buttonList[idNum].click = this.returnSimpleService;
        idNum++;
      });

      if (this.buttonList[idNum]) {
        this.buttonList[idNum].click = this.returnServiceAdd;
      }

      //no good!!!
      //表示対象チェック(表示するボタンと、見えないボタンの数)
      let count = 0;
      for (var i = 0; i < this.buttonList.length; i++) {
        if (this.buttonList[i].isShow || this.buttonList[i].isHidden) {
          count += 1;
        }
      }
      //no good!!!
      //表示対象が4より上だったら4の倍数にする
      if (count > 4 && count % 4 !== 0) {
        for (var m = 0; m < 4 - (count % 4); m++) {
          this.buttonList.push(this.defButtonElement);
        }
      }
      //no good!!!
      //2次元配列で表示データを準備。。。
      this.buttonLine = [];
      let line = [];
      for (var n = 0; n < this.buttonList.length; n++) {
        if (this.buttonList[n].isShow || this.buttonList[n].isHidden) {
          line.push(this.buttonList[n]);
        }
        if (line.length === 4) {
          this.buttonLine.push(line);
          line = [];
        }
      }
      // no good
      // count が4より小さい時は、表示ボタンが出来ていないのでPUSH
      // count が4以上の場合は、4の倍数分しか出来ないので追加しない[機能修正管理表No48]
      if (line.length > 0 && count < 4) {
        this.buttonLine.push(line);
        line = [];
      }
    },
    /**
     * 簡易サービスボタンの言語切り替え
     */
    changeLang(lang) {
      this.buttonList.forEach((item) => {
        if (item.serviceName || item.serviceNameEN) {
          let line1 = '';
          let line2 = '';
          let arr = [];
          let name = lang !== 'en' ? item.serviceName : item.serviceNameEN;
          if (name.includes('<BR>')) {
            arr = name.split('<BR>');
            line1 = arr[0];
            line2 = arr[1];
          }
          item.line1 = !line1 ? name : line1;
          item.line2 = line2;
          if (item.line2) {
            item.linenum = 2;
          }
        }
      });
      // 言語が変わったら、ボタンの再描写(Key更新)
      this.buttonKeyPrefix = lang;
    },
  },
  beforeMount() {
    // IF03を登録
    window.onOpenSettingAppFinished = (error) => {
      this.nativeCallbackResult = NativeCallback.onOpenSettingAppFinished(error);
      const code = this.nativeCallbackResult.errorCode;
      if (NativeCallback.codeInclude(code, '03-E0001')) {
        // 設定アプリ起動失敗の処理(仕様には記述なし)
      }
    };

    window.onResponseNativeAppInfo = (
      error,
      version,
      login,
      device,
      notice,
      biomAuth,
      passcodeAuth
    ) => {
      const appInfo = NativeCallback.onResponseNativeAppInfo(
        error,
        version,
        login,
        device,
        notice,
        biomAuth,
        passcodeAuth
      );

      this.$store.commit('appInfo/setNativeAppInfo', appInfo);
    };
  },
  async mounted() {
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$mq === 'pc') {
      this.listRow = 10;
    } else {
      this.listRow = 5;
    }

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }
    if (this.$store.getters['isLoggedIn']) {
      await this.APP_CO9916();
    }
    this.isVisible = true;
    this.checkAndShowRequestPushNotificationPermissionDialog();

    this.init().catch(() => {
      // console.log(error);
    });

    //no good!!!!!
    //ボタン更新(ここは、警備ユニット/カメラが無いユーザーのために必要)
    this.buttonListUpdate();

    //初期通信完了後に画面を表示
    this.isShowPage = true;
    // loadingDialogコンポーネントの呼び出し
    await this.$loadingDialog();
  },
  watch: {
    isPushNotificationAvailable() {
      this.checkAndShowRequestPushNotificationPermissionDialog();
    },
  },
};
